import React, { useContext, useEffect, useCallback } from "react";
import { Form, Input, Button, Row, Col, Modal, notification, Space, Switch } from "antd";
import axios from "axios";
import GlobalContext from "../../utils/GlobalContext";
// import mergeProps from "../../utils/MergeProps";
import moment from "moment";
import formatTimestamp from "../../utils/FormatTimestamp"
const { TextArea } = Input;
// const { Option } = Select;

const AgreementDecisionFollowupForm = ({ 
    open, 
    onFinish, 
    onCancel, 
    currentAgreementId, 
    currentMeetingPointDetailName,
    currentMeetingPointDetailId,
    nextMeetingStartDate }) => {
  const globals = useContext(GlobalContext);
  const [form] = Form.useForm();
  const [successful, setSuccessful] = React.useState(false);
  const [currentAgreement, setCurrentAgreement] = React.useState(null);

  const fetchCurrentAgreement = useCallback(async () => {
    try {
      if (!currentAgreementId) return;
      await new Promise((resolve) => setTimeout(resolve, 100));
      const response = await axios.get(
        `${globals.SERVICE_API_DB}/v1/consult-agreements/${currentAgreementId}`,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      setCurrentAgreement(response?.data?.data);
    } catch (error) {
      console.error("Error fetching agreement:", error);
      notification.error({
        message: "Error obteniendo acuerdo",
        placement: "bottomRight",
      });
    }
    // setLoadingClients(false);
  }, [globals.SERVICE_API_DB, globals.token, currentAgreementId]);

  useEffect(() => {
    fetchCurrentAgreement();
  }, [fetchCurrentAgreement, currentAgreementId, open]);

  useEffect(() => {
    if (!currentAgreement) return;
    form.setFieldsValue({
      date: (currentAgreement) ? moment(currentAgreement?.date).format("YYYY-MM-DD") : null,
      responsible: currentAgreement?.responsible,
      criterion: currentAgreement?.criterion,
      result: currentAgreement?.result,
      next_meeting_Id: currentAgreement?.next_meeting_Id,
      next_meeting_date: formatTimestamp(nextMeetingStartDate),
    });
    setSuccessful(currentAgreement?.successful);

  }, [form, currentAgreement, open, nextMeetingStartDate]);

  const handleComplete = async (values) => {
    try {
      let request = getRequest();
      request = {...request, ...values};
      request.successful = (successful) ? 1 : 0;
      request.meetingPointDetailId = currentMeetingPointDetailId;
      console.log("request edit", request);
      await axios.put(
        `${globals.SERVICE_API_DB}/v1/update-agreements/${currentAgreementId}`,
        request,
        {
          headers: {
            "x-token": globals.token,
          },
        }
      );
      notification.success({
        message: "Acuerdo actualizado exitosamente!",
        placement: "bottomRight",
        duration: 2,
      });
      form.resetFields();
      onFinish();
    } catch (error) {
      console.error("Error updating agreement:", error);
      notification.error({
        message: "Error actualizando acuerdo",
        placement: "bottomRight",
      });
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onCancel();
  };
  
  const getRequest = () => {
    return {
      "executor": "",
      "implementation": 0,
      "observation" : "",
      "result": "",
      "next_meeting_Id": null,
    }
  }
  return (
    <Modal
      title={"Actualizar acuerdo de decisión"}
      open={open}
      onCancel={handleCancel}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleComplete}>
        <span style={{ fontWeight: "bold" }}>Punto de reunión: </span><span>{currentMeetingPointDetailName}</span>
        <hr />
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item
              name="date"
              label="Fecha acordada de éxito"
              rules={[
                { required: true, message: "Por favor ingrese una fecha" },
              ]}
            >
              <Input
                type="date"
                disabled={true}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              name="next_meeting_date"
              label="Reunión donde se revisará"
              rules={[
                {
                  required: false,
                  message: "Por favor seleccione la próxima reunión",
                },
              ]}
            >
              <Input
                disabled={true}
              />
            </Form.Item>
          </Col>

        </Row>
        <Form.Item
          name="responsible"
          label="Email del responsable del seguimiento de éxito."
          tooltip="Ingrese el correo electrónico del responsable del seguimiento"
          rules={[
            { type: 'email', message: "Ingrese un email válido" },
            { required: true, message: "Por favor ingrese un email" },
          ]}
        >
          <Input
            placeholder="Ingrese el correo electrónico del responsable"
            disabled={true}
          />
        </Form.Item>
        <Form.Item
          name="criterion"
          label="Criterio de éxito"
          rules={[{ required: true, message: "Por favor ingrese el criterio" }]}
        >
          <TextArea
            rows={3}
            disabled={true}
          />
        </Form.Item>
        <Form.Item
          name="result"
          label="Resultado de éxito"
        >
          <TextArea
            rows={3}
          />
        </Form.Item>
        <Form.Item
          name="successful"
        >
          <Space direction="vertical">
            <Switch
              checkedChildren="Exitoso"
              unCheckedChildren="No Existoso"
              onChange={(value) => setSuccessful(value)}
              value={successful}
              disabled={true}
            />
          </Space>
        </Form.Item>
        <Row justify="end">
          <Col>
            <Button
              style={{ marginRight: 8 }}
              type="primary"
              htmlType="submit"
            >
              Actualizar
            </Button>
            <Button style={{ marginRight: 8 }} onClick={handleCancel}>
              Cancelar
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default AgreementDecisionFollowupForm;
